import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BY_TASK } from '../../core/config/modularized.config';

import { loggedInRoute, loggedNotificationInRoute } from '../../core/config/routes.config';
import { TranslationService } from '../../core/services/translation.service';
import { ToasterService } from '../../core/services/visual/toaster.service';
import { AuthService } from '../auth.service';
import { LoginInterface } from './login.interface';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  isMenuByTask: boolean;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toasterService: ToasterService,
    private translationService: TranslationService,
    private titlesService: Title
  ) { }

  ngOnInit() {
    this.isMenuByTask = environment.menu === BY_TASK;
    const title = this.translationService.getTranslationSync('app.title');
    this.titlesService.setTitle(title);
  }

  async onLogin(login: LoginInterface) {
    try {
      await this.authService.login(login.email, login.password);
      const notificationCounter = await this.authService.getUserNotificationIsNotReadCounter();
      if (notificationCounter.counter > 0 && this.isMenuByTask) {
        this.router.navigateByUrl(loggedNotificationInRoute);
      } else {
        this.router.navigateByUrl(loggedInRoute);
      }
    } catch (error) {
      this.toasterService.showErrorTranslating('auth.login.error');
    }
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/auth/login/login.component.ts